import { ReactNode } from 'react';
import { Card, CardContent } from './ui/card';

interface BgBaseCardProps {
  bg?: string;
  children: ReactNode;
}
export default function BgBaseCard({ children, bg }: BgBaseCardProps) {
  return (
    <Card
      className={`border border-[#104573]/8 dark:border-white/8 shadow-sm bg-[#104573]/[0.02] dark:bg-white/[0.02] ${bg} flex-1 h-full overflow-hidden`}
    >
      <CardContent className="flex flex-col flex-1 overflow-hidden">
        {children}
      </CardContent>
    </Card>
  );
}
